/**
 * Defines how the price for billing batch is calculated
 */
export enum BillingPaymentTypeEnum {
    PROCEDURES = 'procedures', // sečíst ceny výkonů
    CLIENTS = 'clients',       // daná částka * počet klientů
    FIXED = 'fixed',           // daná částka
    MAXIMUM = 'maximum',       // sečíst ceny výkonů, shora omezit danou částkou
}

export const billingPaymentTypes = [
    { name: BillingPaymentTypeEnum.PROCEDURES },
    { name: BillingPaymentTypeEnum.CLIENTS },
    { name: BillingPaymentTypeEnum.FIXED },
    { name: BillingPaymentTypeEnum.MAXIMUM },
];
